import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./ui/tooltip";

export default function MetricInfo({ text }) {
  if (!text) return null;
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className="inline-flex items-center justify-center rounded p-0.5 text-muted-foreground hover:text-foreground"
            aria-label="Metric info"
          >
            <Info className="h-4 w-4" />
          </button>
        </TooltipTrigger>
        <TooltipContent side="top">
          <p className="max-w-xs leading-snug">{text}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
